import React from 'react';
import { MapPin } from 'lucide-react';
import Logo from './Logo';

const MobileStartupCard = ({ startup, active, onSelect }) => (
  <button
    data-testid="mobile-startup-card"
    onClick={() => onSelect(startup.id)}
    className={`snap-center shrink-0 w-[82vw] max-w-[340px] h-fit self-start text-left rounded-2xl p-4 bg-white flex flex-col shadow-sm border transition-transform active:scale-[0.99] focus-visible:ring-2 focus-visible:ring-slate-400 ${
      active ? 'border-slate-900 ring-2 ring-slate-900/10' : 'border-slate-200'
    }`}
  >
    <div className="flex items-start gap-3">
      <Logo startup={startup} size={44} />
      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-semibold text-slate-900 text-[15px] leading-tight truncate">{startup.name}</h3>
        </div>
        <p className="text-[12.5px] text-slate-500 leading-snug mt-1 line-clamp-2">{startup.description}</p>
      </div>
    </div>
    <div className="mt-3">
      <span className="inline-flex items-center text-[11px] font-medium px-2 py-1 rounded-md bg-emerald-50 text-emerald-700 border border-emerald-100">
        {startup.sector}
      </span>
    </div>
    <div className="mt-2.5 flex items-center gap-1.5 text-[12px] text-slate-500">
      <MapPin size={12} className="text-rose-500 shrink-0" fill="currentColor" />
      <span className="truncate">{startup.address}</span>
    </div>
  </button>
);

export default MobileStartupCard;
